import { PopupStatus } from "./PopupReducer";

export enum PopupActionTypes {
    UPDATE_STATUS = "@popup/status",
    SET_CUSTOM_CONTEXT = "@popup/custom-context"
}
export type PopupActions =
    | { type: PopupActionTypes.UPDATE_STATUS, status: PopupStatus }
    | { type: PopupActionTypes.SET_CUSTOM_CONTEXT, updatedContext: any };

export const setPopupStatus = (status: PopupStatus) => ({ type : PopupActionTypes.UPDATE_STATUS, status: status })
export const setCustomContext = (updatedContext: any) => ({ type : PopupActionTypes.SET_CUSTOM_CONTEXT, updatedContext })